import { VHeaders } from '@/models/pagedlistmodel';

export function getSoldVehicleHeaders(): VHeaders[] {
  return [
    {
      text: '',
      align: 'left',
      isNotDataProp: true,
      sortable: false,
    },
    {
      text: 'Vin',
      align: 'left',
      value: 'vin',
      sortable: true,
    },
      {
      text: 'Stock Number',
      align: 'left',
      value: 'stockNumber',
      sortable: true,
    },
    {
      text: 'Order Number',
      align: 'left',
      value: 'orderNumber',
      sortable: false,
    },

      {
      text: 'Invoice Amount',
      align: 'right',
      value: 'invoiceAmount',
      sortable: false,
    },
    {
      text: 'Flooring Payoff',
      align: 'right',
      value: 'flooringPayoff',
      sortable: false,
    },
   
    {
      text: 'Hold Back',
      align: 'right',
      value: 'holdBack',
      sortable: false,
    },
    {
      text: 'Floorplan Assistance',
      align: 'left',
      value: 'floorplanAssistance',
      sortable: false,
    },
    {
      text: 'Base Retail Amount',
      align: 'right',
      value: 'baseRetailAmount',
      sortable: false,
    },
    {
      align: 'left',
      sortable: true,
      text: 'CreatedAt',
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      text: 'OCR Status',
      align: 'left',
      value: 'ocrStatus',
      sortable: false,
    },
    {
      text: 'DMS Status',
      align: 'left',
      value: 'dmsStatus',
      sortable: false,
    },
    
    {
      text: 'Error Message',
      align: 'left',
      value: 'errorMessage',
      sortable: false,
      fieldType: 'template',
      template: (item) => {
                if (item.stockNumber && item.stockNumber != "")
                      return `<span> N/A </span>`;
                else
                      return `<span style="color: red">${item.errorMessage?item.errorMessage:'N/A'}</span>`;
                    
      }
    },
    {
      align: 'left',
      text: 'Action',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

// export function getChargeCustomerAttachmentHeaders(vm: any): VHeaders[] {
//   return [
//     {
//       text: vm.$parent.$t('chargeCustomerAttachments.attachmentHeaders.attachmentType') as string,
//       align: 'left',
//       value: 'attachmentTypeName',

//     },
//     {
//       text: vm.$parent.$t('chargeCustomerAttachments.attachmentHeaders.uploadedAt') as string,
//       align: 'left',
//       value: 'createdAt',
//       fieldType: 'date',
//     },
//     {
//       text: vm.$parent.$t('chargeCustomerAttachments.attachmentHeaders.comments') as string,
//       align: 'left',
//       value: 'comment',
//     },
//     {
//       text: vm.$parent.$t('chargeCustomerAttachments.attachmentHeaders.action') as string,
//       align: 'center',
//       isNotDataProp: true,
//       sortable: false,
//     },
//   ];
// }
